"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionEditor = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./AlgorithmEditor.css"));
var metricNameMap = Object.freeze({
    PageViewCount: "Page views",
    PageViewDuration: "Minutes spent on page",
});
var operatorDescriptionMap = Object.freeze({
    ">=": "are greater than or equal to",
    ">": "are greater than",
    "<=": "are less than or equal to",
    "<": "are less than",
    "==": "are equal to",
});
var ConditionEditor = function (_a) {
    var leafNode = _a.leafNode, onChange = _a.onChange, onDelete = _a.onDelete;
    function onThresholdChange(newValue) {
        var parsedValue = parseInt(newValue);
        var newThresholdValue = Number.isNaN(parsedValue) ? 0 : parsedValue;
        onChange(__assign(__assign({}, leafNode), { values: __assign(__assign({}, leafNode.values), { threshold: newThresholdValue }) }));
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", gap: "xs" },
        react_1.default.createElement("div", { className: styles.conditionDescriptor },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true }, metricNameMap[leafNode.values.metric]),
            " ",
            react_1.default.createElement(kaleidoscope_1.Text, null, operatorDescriptionMap[leafNode.values.operator])),
        react_1.default.createElement(kaleidoscope_1.TextInput, { className: styles.thresholdInput, value: "".concat(leafNode.values.threshold), onChange: onThresholdChange, type: kaleidoscope_1.TextInputType.Number, label: "Threshold", labelHidden: true, inputMode: "numeric" }),
        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Delete, null), isDestructive: true, onClick: onDelete })));
};
exports.ConditionEditor = ConditionEditor;
